/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { EntityCategoryType } from './entityCategory';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-sub-categories';

export const EntitySubCategoryApi = {
  findWithEntity: async () => {
    const url = `${pathname}/entity`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: EntitySubCategoryQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  switch: async (body: SwitchEntitySubCategory) => {
    const url = `${pathname}/switch`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  switchForCollaboratorProducts: async (
    body: SwitchEntitySubCategoryForCollaboratorProducts
  ) => {
    const url = `${pathname}/switch-for-collaborator-products`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForAddMultiProducts: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/products/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForAddMultiCollaboratorProducts: async (
    id: string,
    option: FindOneOptions
  ) => {
    let url = `${pathname}/collaborator-products/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: UpdateEntitySubCategory) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSort: async (params: UpdateEntitySubCategorySort) => {
    const { body, entityCategoryID } = params;

    const url = `${pathname}/${entityCategoryID}/sort`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntitySubCategoryType {
  id: string;
  shortID?: string;
  name: string;
  subCategoryID: string;
  entityID: string;
  entitySubCategoryID: string;
  code?: string;
  status: number;
  avatar: string;
  order: number;
  isDefault: boolean;
  createdAt: string;
  subCategory?: any;
  entityCategory?: EntityCategoryType;
}

export interface UpdateEntitySubCategory {
  id: string;
  categoryID: string;
  option: {
    targetType: string;
  };
  body: any;
}

interface UpdateOrder {
  id: string;
  order: number;
}

export interface UpdateEntitySubCategorySort {
  entityCategoryID: string;
  body: {
    listEntitySubCategory: UpdateOrder[];
  };
}

export interface SwitchEntitySubCategory {
  productIDs: string[];
  targetEntitySubCategoryID: string;
}

export interface SwitchEntitySubCategoryForCollaboratorProducts {
  collaboratorProductIDs: string[];
  targetEntitySubCategoryID: string;
}

export interface EntitySubCategoryQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
  entityCategoryID?: string;
}
